<template>
  <section class="how-it-works">
    <h1 class="section-title">How it works?</h1>
    <div class="steps">
      <div class="step" v-for="(item, index) in steps" :key="index">
        <div class="step-number">{{ index + 1 }}</div>
        <h3>{{ item.title }}</h3>
        <p>{{ item.text }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HowItWorks",
  data() {
    return {
      steps: [
        {
          title: "Download the app",
          text: "Install StreamBox on Android TV, Firestick, Samsung, LG or any phone & tablet."
        },
        {
          title: "Add your playlist",
          text: "Upload your M3U IPTV playlist or use recommended free lists instantly."
        },
        {
          title: "Start watching",
          text: "Enjoy live TV, movies and radio in one modern app interface."
        }
      ]
    };
  }
};
</script>

<style scoped>
.how-it-works {
  background-color: #020716;
  color: white;
  padding: 60px 20px;
  text-align: center;
}

.section-title {
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 40px;
  color: #ffffff;
}

.steps {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}

.step {
  background-color: #000a1b25;
  border: 1px solid #222;
  border-radius: 10px;
  padding: 30px 20px;
  width: 280px;
  text-align: center;
}

.step-number {
  background-color: #00ccff;
  color: #ffffff;
  font-weight: bold;
  font-size: 20px;
  width: 36px;
  height: 36px;
  line-height: 36px;
  margin: 0 auto 20px auto;
  border-radius: 50%;
}

.step h3 {
  font-size: 24px;
  margin-bottom: 10px;
  color: white;
}

.step p {
  font-size: 16px;
  color: #bbbbbb;
  line-height: 1.5;
}
</style>
